"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AD_ELIGIBLE_PAID_STORY_IDS = void 0;
// prettier-ignore
exports.AD_ELIGIBLE_PAID_STORY_IDS = [
    351778437,
    353857613,
    354581247,
    356139381,
    356871001,
    362219749,
    376491228,
    378335220,
    380063665,
    385625407,
    90623050,
];
